export default function () {
	$(document).on("click", ".js-visible-password", e => {
		const element = $(e.currentTarget);
		const input = element.parents(".js-form-field").find("input");
		element.toggleClass("active");

		if (input.attr("type") === "text") {
			input.attr("type", "password");
			element.attr(
				"aria-label",
				"Show password as plain text. " +
					"Warning: this will display your password on the screen."
			);
		} else {
			input.attr("type", "text");
			element.attr("aria-label", "Hide password.");
		}
	});
}
